import React from "react";
import { Link } from "react-router-dom";
import { Bell, ChevronRight } from "lucide-react";
import { useAuth } from "../lib/AuthContext";

const NotificationBanner = () => {
  const { user, unreadCount } = useAuth();
  if (!user || !unreadCount) return null;

  const label =
    unreadCount === 1
      ? "Tem uma nova resposta da oficina"
      : `Tem ${unreadCount} novas respostas da oficina`;

  return (
    <Link
      to="/os-meus-orcamentos"
      data-testid="home-notification-banner"
      className="fixed left-0 right-0 top-24 md:top-28 z-40 block bg-gradient-to-r from-[#FF5A00]/25 via-[#FF5A00]/15 to-[#0E2452]/80 backdrop-blur-md border-b border-[#FF5A00]/40 hover:from-[#FF5A00]/40 hover:via-[#FF5A00]/25 transition-all"
      style={{ animation: "notifSlideDown 400ms ease-out" }}
    >
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center gap-3">
        <div className="relative w-9 h-9 shrink-0 rounded-full bg-[#FF5A00] flex items-center justify-center">
          <Bell className="w-4 h-4 text-white" strokeWidth={2.5} />
          <span className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-red-500 border-2 border-[#0A0A0A] text-white text-[9px] font-display font-bold flex items-center justify-center">
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-display font-bold uppercase text-white text-xs md:text-sm tracking-wider leading-tight">
            {label}
          </div>
          <div className="text-white/60 text-[11px] md:text-xs font-body truncate">
            Clique para abrir os seus orçamentos e ver a resposta.
          </div>
        </div>
        <div className="shrink-0 inline-flex items-center gap-1 text-[#FF5A00] font-display font-bold uppercase text-[11px] tracking-widest">
          Ver resposta
          <ChevronRight className="w-4 h-4" />
        </div>
      </div>
      <style>{`
        @keyframes notifSlideDown {
          from { opacity: 0; transform: translateY(-8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </Link>
  );
};

export default NotificationBanner;
